import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import { EmptyState } from '@atlassian/search-dialog';
import { messages } from '../messages';
import { FormattedMessage } from 'react-intl-next';
export var PrequeryEmptyScreenIcon = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/search-ai/prequery-empty-screen-icon" */'./image');
});
export var PreQueryEmptyScreen = function PreQueryEmptyScreen(_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/React.createElement(EmptyState, {
    Image: PrequeryEmptyScreenIcon,
    title: /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_no_content_header),
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_no_content_body)
  });
};